export enum EViewer{
  Viewer = "Output", 
  Flowchart = "Flowchart", 
  Editor = "Procedure", 
  Parameter = "Parameters"
}


// WEBPACK FOOTER //
// C:/Users/Akshata/Documents/GitHub/mobius-dev/src/app/ui-components/viewers/EViewer.ts